module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"contact-pro.request-meeting":"Vraag een kennismakingsgesprek aan"},"en-GB":{"contact-pro.request-meeting":"Request a free information meeting!"}}')
  delete Component.options._Ctor
}
